// import { useEffect, useState } from "react";
// import axios from "axios";

// export default function AdminContacts() {
//   const [messages, setMessages] = useState([]);


//   useEffect(() => {
//     axios
//       .get("http://localhost:8080/api/contact/admin/messages")
//       .then((res) => setMessages(res.data));
//   }, []);



//   useEffect(() => {
//     axios.get("http://localhost:8080/api/contact")
//       .then(res => setMessages(res.data));
//   }, []);

//   return (
//     <div className="container mt-4">
//       <h2>📩 Contact Messages</h2>

//       <table className="table table-bordered mt-3">
//         <thead>
//           <tr>
//             <th>Name</th>
//             <th>Email</th>
//             <th>Message</th>
//             <th>Date</th>
//           </tr>
//         </thead>
//         <tbody>
//           {messages.map(msg => (
//             <tr key={msg.id}>
//               <td>{msg.name}</td>
//               <td>{msg.email}</td>
//               <td>{msg.message}</td>
//               <td>{msg.createdAt?.slice(0,10)}</td>
//             </tr>
//           ))}
//         </tbody>
//       </table>
//     </div>
//   );
// }
  

// import { useEffect, useState } from "react";
// import axios from "axios";

// export default function AdminContacts() {
//   const [messages, setMessages] = useState([]);

//   // 🔹 Load messages from backend
//   useEffect(() => {
//     axios
//       .get("http://localhost:8080/api/contact/admin/messages")
//       .then((res) => setMessages(res.data))
//       .catch((err) => console.error(err));
//   }, []);

//   return (
//     <div className="container mt-4">
//       <h2>📩 Contact Messages</h2>

//       <table className="table table-bordered mt-3">
//         <thead className="table-dark">
//           <tr>
//             <th>Name</th>
//             <th>Email</th>
//             <th>Message</th>
//             <th>Status</th>
//             <th>Reply</th>
//           </tr>
//         </thead>

//         <tbody>
//           {messages.map((msg) => (
//             <tr key={msg.id}>
//               {/* NAME */}
//               <td>{msg.name}</td>

//               {/* EMAIL */}
//               <td>{msg.email}</td>

//               {/* MESSAGE */}
//               <td>{msg.message}</td>

//               {/* STATUS */}
//               <td>
//                 {msg.replied ? (
//                   <span className="badge bg-success">Replied</span>
//                 ) : (
//                   <span className="badge bg-warning text-dark">Pending</span>
//                 )}
//               </td>

//               {/* REPLY */}
//               <td>
//                 {!msg.replied && (
//                   <>
//                     <textarea
//                       className="form-control mb-2"
//                       placeholder="Type reply here..."
//                       onChange={(e) =>
//                         setMessages((prev) =>
//                           prev.map((m) =>
//                             m.id === msg.id
//                               ? { ...m, replyText: e.target.value }
//                               : m
//                           )
//                         )
//                       }
//                     />

//                     <button
//                       className="btn btn-primary btn-sm"
//                       onClick={() => {
//                         axios
//                           .post(
//                             `http://localhost:8080/api/contact/admin/reply/${msg.id}`,
//                             { reply: msg.replyText }
//                           )
//                           .then(() => window.location.reload());
//                       }}
//                     >
//                       Send Reply
//                     </button>
//                   </>
//                 )}
//               </td>
//             </tr>
//           ))}
//         </tbody>
//       </table>
//     </div>
//   );
// }


//******* 7/1/26***** */

import { useEffect, useState } from "react";
import axios from "axios";

export default function AdminContacts() {
  const [messages, setMessages] = useState([]);
  const [replyInputs, setReplyInputs] = useState({}); // Track what is being typed per message ID

  // Load messages from backend
  const fetchMessages = () => {
    axios
      .get("http://localhost:8080/api/contact/admin/messages")
      .then((res) => setMessages(res.data))
      .catch((err) => console.error("Fetch error:", err));
  };

  useEffect(() => {
    fetchMessages();
  }, []);

  // Handle typing in the reply box
  const handleInputChange = (id, value) => {
    setReplyInputs((prev) => ({ ...prev, [id]: value }));
  };

  // Handle sending the reply to the backend
  const handleSendReply = (id) => {
    const replyText = replyInputs[id];
    if (!replyText) return alert("Please type a reply first.");

    axios
      .post(`http://localhost:8080/api/contact/admin/reply/${id}`, {
        reply: replyText,
      })
      .then(() => {
        alert("Reply sent and email triggered!");
        setReplyInputs((prev) => ({ ...prev, [id]: "" })); // Clear input
        fetchMessages(); // Refresh the list to show "Replied" status
      })
      .catch((err) => console.error("Reply error:", err));
  };

  return (
    <div className="container mt-5">
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h2 className="fw-bold">📩 Guest Inquiries</h2>
        <span className="badge bg-info p-2">Total: {messages.length}</span>
      </div>

      <div className="table-responsive shadow-sm rounded">
        <table className="table table-hover align-middle bg-white">
          <thead className="table-dark">
            <tr>
              <th>Guest Name</th>
              <th>Email</th>
              <th>Message</th>
              <th>Status</th>
              <th style={{ width: "30%" }}>Admin Action</th>
            </tr>
          </thead>
          <tbody>
            {messages.length === 0 ? (
              <tr><td colSpan="5" className="text-center py-4">No messages found.</td></tr>
            ) : (
              messages.map((msg) => (
                <tr key={msg.id}>
                  <td><strong>{msg.name}</strong></td>
                  <td>{msg.email}</td>
                  <td><small>{msg.message}</small></td>
                  <td>
                    {msg.replied ? (
                      <span className="badge bg-success">Replied</span>
                    ) : (
                      <span className="badge bg-warning text-dark">Pending</span>
                    )}
                  </td>
                  <td>
                    {!msg.replied ? (
                      <div className="d-flex flex-column">
                        <textarea
                          className="form-control form-control-sm mb-2"
                          placeholder="Type your reply..."
                          value={replyInputs[msg.id] || ""}
                          onChange={(e) => handleInputChange(msg.id, e.target.value)}
                        />
                        <button
                          className="btn btn-primary btn-sm"
                          onClick={() => handleSendReply(msg.id)}
                        >
                          Send Email
                        </button>
                      </div>
                    ) : (
                      <div className="text-muted small">
                        <strong>Reply Sent:</strong> {msg.reply}
                      </div>
                    )}
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}